import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/apiservice/apiservice.service';
import { ConfigService } from '../../../services/config/config.service';
import { ApiResponse } from './../../../services/api-response.interface';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { INotifyMessage } from './notify-messages.interface';

@Injectable()
export class NotifyService {
  openNotificationBS = new BehaviorSubject<any>(null);
  unreadMessageCount$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private _messageUpdateTimer: number;

  constructor(
    private _apiserviceService: ApiService,
    private _configService: ConfigService,
    private _http: HttpClient,
  ) {}

  startUnreadMessageCountUpdates(): void {
    this.updateUnreadMessageCount();

    //schedule the notification to fire regularly
    const intervalMilliseconds =
      this._configService.unreadMessageFetchIntervalInMinutes * 60 * 1000;
    this._messageUpdateTimer = window.setInterval(
      () => this.updateUnreadMessageCount(),
      intervalMilliseconds,
    );
  }

  stopUnreadMessagecountUpdates(): void {
    if (this._messageUpdateTimer) {
      window.clearInterval(this._messageUpdateTimer);
      this._messageUpdateTimer = undefined;
    }
  }

  getNotificationMessages(): Observable<INotifyMessage> {
    const url = `${this._configService.agApi}/Motd`;
    return this._http.get<ApiResponse<INotifyMessage>>(url).pipe(map((response) => response.data));
  }

  updateUnreadMessageCount() {
    const unreadCountUrl = `${this._configService.agApi}/Motd/unread-count`;
    this._http
      .get<ApiResponse<number>>(unreadCountUrl)
      .pipe(map((response) => response.data))
      .subscribe(
        (count) => {
          this.unreadMessageCount$.next(count);
        },
        (error: unknown) => console.log('Unable to retrieve Unread Message Count', error),
      );
  }

  ackMessage(data): Observable<any> {
    const url = `${this._configService.agApi}/Motd/ack`;
    return this._apiserviceService.post(url, data);
  }

  setOpenNotSideNavBS(value) {
    this.openNotificationBS.next(value);
  }
  getOpenNotSideNavBS() {
    return this.openNotificationBS.asObservable();
  }
}
